// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__31GKe","col":"styles_col__azdM4","fulfillmentStatus":"styles_fulfillmentStatus__H5eDT","emailCol":"styles_emailCol__3XA4b"};